export default {
  copyright: 'COPYRIGHT © {renderHostName} All Rights RESERVED',
  homePage: 'vào trang chủ',
  download: 'Tải app xuống',
  register: 'Đăng kí ngay',
  service: 'cskh trực tuyến',
  close: 'Đóng tắt',
  enter: 'Nhập vào ngay',
};
